<script>
// 报纸详情
const newspaperSearchUrl = "https://names.library.sh.cn/es/jdbk/newspaper/search";
const newspaperDetailUrl = "https://names.library.sh.cn/es/jdbk/newspaper";
const newspaperIssusegroupUrl = "https://names.library.sh.cn/es/jdbk/newspaper/issusegroup";
const newspaperIssusebytimeUrl = "https://names.library.sh.cn/es/jdbk/newspaper/issusebytime";
// 报-篇信息
const byissueNewspaperUrl = "https://names.library.sh.cn/es/jdbk/article/byissue/newspaper";
// 期刊详情
const magazineSearchUrl = "https://names.library.sh.cn/es/jdbk/magazine/search";
const magazineDetailUrl = "https://names.library.sh.cn/es/jdbk/magazine";
const magazineIssusegroupUrl = "https://names.library.sh.cn/es/jdbk/magazine/issusegroup";
const magazineIssusebytimeUrl = "https://names.library.sh.cn/es/jdbk/magazine/issusebytime";
// 刊-文章信息
const byissueMagazineUrl = "https://names.library.sh.cn/es/jdbk/article/byissue/magazine";

// 报刊列表页
const articleSearchUrl = "https://names.library.sh.cn/es/jdbk/article/search";
const mrPersonMultsearchUrl = 'https://names.library.sh.cn/es/mrPerson/multsearch';

// 可视化
const articleVisualizationUrl = "https://names.library.sh.cn/es/jdbk/article/visualization";

// 海派品牌home
const brandHomeSearchUrl = "https://names.library.sh.cn/es/jdbk/brand/search";

// 海派品牌详情
const brandDetailUrl = "https://names.library.sh.cn/es/jdbk/brand";

// 海派品牌广告图片
const adSearchUrl = "https://names.library.sh.cn/es/jdbk/ad/search";

// 品牌可视化
const adVisualizationUrl = "https://names.library.sh.cn/es/jdbk/ad/visualization";

// 生成manifest
const createManifestUrl = "https://dhc.library.sh.cn/sas/admin/createManifest";

// 获取manifest
const manifestGetUrl = "https://ldy.library.sh.cn/manifest/get";

// 保存manifest
const manifestAddUrl = "https://ldy.library.sh.cn/manifest/add";

const getCanvasPageUrl = 'https://dhc.library.sh.cn/sas/getCanvasPage'; // 获取全文页码
const magazineFullManifests = { // 刊 全文 magazine Manifests
    192531: 'https://dhc.library.sh.cn/sas/manifest/77ydje2wi2slaijbc5kv9lt93v2odfpz.json',
    192810: 'https://dhc.library.sh.cn/sas/manifest/77lfjoc1g8gfvu1jnvbs52km89wwqwin.json',
    192811: 'https://dhc.library.sh.cn/sas/manifest/zbdsz6x7seesj6i8zkxs8fxwohbf1igh.json',
    192816: 'https://dhc.library.sh.cn/sas/manifest/4e89atq3ji48ifotkyzah7jykhlow9xo.json'
    // 192531: 'https://dhc.library.sh.cn/sas/manifest/z7e514rjrgfm4qbng5i92j15qh5atre7.json',
    // 192810: 'https://dhc.library.sh.cn/sas/manifest/4rz7w2a9q38czqo49qg8ugzsddogcrhy.json',
    // 192811: 'https://dhc.library.sh.cn/sas/manifest/ufgcn3x2x3d1j4s4c3w3acl8ajfeqx2r.json',
    // 192816: 'https://dhc.library.sh.cn/sas/manifest/eb7lqi4o5mkn37gcizqompca2q74ojmj.json'
}
const newspaperFullManifest = { // 报 全文 newspaper Manifests
    tiXiaoYinYuan: 'https://dhc.library.sh.cn/sas/manifest/tuph5dnxt21z7azu9dwke9qkra4didbq.json'
}

// 报刊首页描述
const bkHomeDescription = "截止2020年10月，已收录报纸510余种、篇目140760余条、广告44210余条、图片20张；期刊8种、篇目30余条、图片16张。";

export default {
    newspaperSearchUrl,
    newspaperDetailUrl,
    newspaperIssusegroupUrl,
    newspaperIssusebytimeUrl,
    byissueNewspaperUrl,
    magazineSearchUrl,
    magazineDetailUrl,
    magazineIssusegroupUrl,
    magazineIssusebytimeUrl,
    byissueMagazineUrl,
    articleSearchUrl,
    mrPersonMultsearchUrl,
    articleVisualizationUrl,
    brandHomeSearchUrl, // 海派品牌home
    brandDetailUrl,     // 海派品牌详情
    adSearchUrl,        // 海派品牌广告图片
    adVisualizationUrl, // 品牌可视化
    createManifestUrl,  // 生成manifest
    manifestGetUrl,     // 获取manifest
    manifestAddUrl,     // 保存manifest
    getCanvasPageUrl,
    newspaperFullManifest, // 报 全文 Manifests
    magazineFullManifests, // 刊 全文 Manifests
    bkHomeDescription,  // 报刊首页描述
}
</script>